import { oz } from '@weft/utils';
import { ContactSchema } from '../../primitives';
import { withNullAsOptional } from '../../utils/literal-transforms';
import { NewAccountSettingsSchema } from '../account-settings/new-account-settings-schema';

export const NewAccountSchema = oz.object({
  name: oz.string().nonempty(),
  logoUrl: oz.string().optional(),
  settings: NewAccountSettingsSchema,
  contact: withNullAsOptional(ContactSchema),
}).openapi('NewAccount');

export type NewAccount = oz.infer<typeof NewAccountSchema>;